/**
 * 共享资源api
 */
import { getFetch,postFetch } from '@/plugins/http'

const baseHost = `${process.env.VUE_APP_HOST}/hike-boot`

export default {
    //教研室列表
    getJiaoyanshi(params = {}, config) {
        return getFetch(`${baseHost}/common/api/33-jiaoyanshi_list/portal_view`, params, config)
    },
    //机构列表
    getOrganTreeShare(params = {}, config) {
        return getFetch(`${baseHost}/common/api/33-organ_tree_list/portal_view`, params, config)
    },
    //学期列表
    getTermListShare(params = {}, config) {
        return getFetch(`${baseHost}/common/api/33-term_list/lesson_plan_center_portal`, params, config)
    },
    //资源分类
    getTypeListShare(params = {}, config) {
        return getFetch(`${baseHost}/common/api/33-type_list/portal_view`, params, config)
    },
    //列表
    getResourcesListShare(params = {}, config) {
        return getFetch(`${baseHost}/common/api/34-jyzx_all_resource_homepage_list/portal_view`, params, config)
    },
}